import { ConfirmActionButton } from "./ConfirmActionButton";

// TODO: Use this instead of buttons in other pages
interface DeleteButtonProps {
  /** Async delete handler; should return true on success */
  handleDelete: () => Promise<boolean>;
  /** Optional button label, defaults to "Delete" */
  buttonLabel?: string;
  /** Confirmation message, defaults to generic */
  confirmMessage?: string;
  /** If false, skips confirmation modal and deletes immediately */
  requireConfirmation?: boolean;
  disabled?: boolean
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  handleDelete,
  buttonLabel = 'Delete',
  confirmMessage = 'Are you sure you want to delete this item? This action cannot be undone.',
  requireConfirmation = true,
  disabled = false
}) => (
  <ConfirmActionButton
    onAction={handleDelete}
    variant="danger"
    actionLabel="Delete"
    mnemonic="d"
    confirmTitle="Confirm Deletion"
    confirmMessage={confirmMessage}
    buttonLabel={buttonLabel}
    requireConfirmation={requireConfirmation}
    disabled={disabled}
  />
);

export default DeleteButton;
